/**
 * Theme Requirements Aggregation for Cobalt
 * 
 * Extends the base landing-page theme requirements with Cobalt specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-landing-page/requirements';

/**
 * Cobalt component requirement overrides.
 * Add requirements for any override components here.
 */
const cobaltOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Cobalt theme.
 * Inherits from landing-page theme and overrides with Cobalt components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...cobaltOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
